<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true">
    <template v-slot:body>
      <div>
        <div class="flex">
          <div id="creativity">
            <img :src="getIconUrl" />
          </div>
          <div id="study-set-info">
            <h4 id="success-modal-message">{{ $t('study_sets.modals.createSuccess.message') }}</h4>
            <div class="detail">
              <p class="info-row">
                {{ $t('study_sets.modals.createSuccess.study_set_name_label') }}: <span>{{ studySetName }}</span>
              </p>
              <p class="info-row">
                {{ $t('study_sets.modals.createSuccess.count_of_item_label') }}: <span>{{ countOfPhrases }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="flex">
          <elsa-button customIcon="plus-blue" @click.native="handleCreateNewSet" :icon-left="true" class="new-study-set"> {{ $t('study_sets.modals.createSuccess.create_another_study_set') }}</elsa-button>
          <primary-button class="assign-class" ref="" @click.native="handleAssignToClass">
            {{ $t($i18nLabelsHelper(currentOrganizationType, `study_sets.assign_to_another_group`)) }}
          </primary-button>
          <tertiary-button @click.native="$emit('closed')">
            {{ $t('study_sets.modals.createSuccess.done') }}
          </tertiary-button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import PrimaryButton from '@/components/common/buttons/PrimaryButton'
import ElsaButton from '@/components/common/buttons/Button'
import TertiaryButton from '@/components/common/buttons/TertiaryButton'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    studySetName: {
      type: String
    },
    countOfPhrases: {
      type: Number
    }
  },
  components: {
    Modal,
    ElsaButton,
    PrimaryButton,
    TertiaryButton
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType'
    }),
    getIconUrl() {
      return require(`@/assets/images/studyset-creativity.svg`)
    },
    getTitle() {
      return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, 'modals.delete.title'), {
        numberOfClasses: this.numberOfSelectedClasses
      })
    }
  },
  methods: {
    handleLeave() {
      this.$emit('closed')
    },
    handleCreateNewSet() {
      this.$emit('new-set')
    },
    handleAssignToClass() {
      this.$emit('assign-class')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.new-study-set {
  color: $hyperlink;
  padding-left: 0px !important;
  padding-bottom: 0px !important;
  margin-top: auto;
}

.new-study-set {
  &::v-deep span {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 12px;
      width: 12px;
      fill: $hyperlink;
      padding-left: 0px;
    }
  }
}

.new-study-set:hover {
  color: $hyperlink;

  &::v-deep span {
    img {
      fill: $hyperlink-hover;
    }
  }
}

.detail {
  margin-top: 24px;
}
.info-row {
  margin: 0px 0px 8px 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: $black;
  span {
    font-size: 18px;
    font-weight: 600;
  }
}
#study-set-info {
  margin-left: 40px;
  padding-top: 16px;
  padding-bottom: 16px;
}
#success-modal-message {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;

  color: $black;
  margin: 0 auto;
  white-space: pre-wrap;
}

.elsa-button.assign-class,
.elsa-button.assign-class:hover {
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 32px;
  margin-left: auto;
}

::v-deep {
  .el-dialog.elsa-modal {
    width: 720px;
    .el-dialog__header,
    .el-dialog__body {
      // display: flex;
      background-color: white;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      padding: 24px 32px 32px 32px;
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}
</style>
